import { render, staticRenderFns } from "./SoundEffects.vue?vue&type=template&id=67d184a2&scoped=true&"
import script from "./SoundEffects.vue?vue&type=script&lang=js&"
export * from "./SoundEffects.vue?vue&type=script&lang=js&"
import style0 from "./SoundEffects.vue?vue&type=style&index=0&id=67d184a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d184a2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/finnkelly/Code/Go Remote/remote-chat-finn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67d184a2')) {
      api.createRecord('67d184a2', component.options)
    } else {
      api.reload('67d184a2', component.options)
    }
    module.hot.accept("./SoundEffects.vue?vue&type=template&id=67d184a2&scoped=true&", function () {
      api.rerender('67d184a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/GroupTeams/Common/SoundEffects.vue"
export default component.exports